import { addError } from '@infra/datadog/tracking';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';

import { IS_UNSUPPORTED_BROWSER } from '@libs/browserSupport';
import { ErrorsNotificationProvider } from '@providers/ErrorsNotificationProvider';
import { MediaQueryProvider } from '@providers/MediaQueryProvider';
import { ThemeProvider } from '@providers/ThemeProvider';
import { TranslateProvider } from '@providers/TranslateProvider';

import { NotFoundPage } from '@features/auth/pages/NotFoundPage';
import { AuthProvider } from '@features/auth/providers/AuthProvider/AuthProvider';
import { useAutoGameRedirect } from '@features/game/hooks/useAutoGameRedirect';
import { useDeployDetector } from '@features/shared/hooks/useDeployDetector';
// import { useSyncTimeOnce } from '@features/shared/hooks/useSyncTimeOnce';
import { BrowserNotSupportedPage } from '@features/shared/pages/BrowserNotSupportedPage/BrowserNotSupportedPage';

/*
    ____,-------------------------------,____
    \   |              Роут             |   /
    /___|-------------------------------|___\
*/

const queryClient = new QueryClient();

export const Route = createRootRoute({
  component: () =>
    IS_UNSUPPORTED_BROWSER ? (
      <BrowserNotSupportedPage />
    ) : (
      <>
        <MediaQueryProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <ErrorsNotificationProvider>
                <AuthProvider>
                  <TranslateProvider>
                    <Outlet />
                  </TranslateProvider>
                  <GlobalHooks />
                </AuthProvider>
              </ErrorsNotificationProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </MediaQueryProvider>
      </>
    ),
  notFoundComponent: () => <NotFoundPage />,
});

/*
    ____,-------------------------------,____
    \   |       Browser support         |   /
    /___|-------------------------------|___\
*/

if (IS_UNSUPPORTED_BROWSER) {
  class BrowserNotSuported extends Error {}
  addError(new BrowserNotSuported('Browser is not supported'));
}

/*
    ____,-------------------------------,____
    \   |        Global Hooks           |   /
    /___|-------------------------------|___\
*/

function GlobalHooks() {
  // Автоматический редирект на игру, если она началась или скоро начнётся
  useAutoGameRedirect();

  // Синхронизация времени
  // FIXME: реализовать более надёжный алгоритм c сэмплами и не по REST
  // useSyncTimeOnce();

  // Детектор релизов (автоматически рефрешит сайт)
  useDeployDetector();

  return null;
}
